// extracted by mini-css-extract-plugin
module.exports = {"image":"s3","hidden":"s4"};